import { render, staticRenderFns } from "./ArticlesFilters.vue?vue&type=template&id=05bf7450&scoped=true"
import script from "./ArticlesFilters.vue?vue&type=script&lang=js"
export * from "./ArticlesFilters.vue?vue&type=script&lang=js"
import style0 from "./ArticlesFilters.vue?vue&type=style&index=0&id=05bf7450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bf7450",
  null
  
)

export default component.exports